import { Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./components/ProtectedRoutes/ProtectedRoutes";
import RoleProtectedRoutes from "./components/RoleProtectedRoutes/RoleProtectedRoutes";
import GlobalStyle from "./container/GlobalStyle";
import Admin from "./Page/Admin/Admin";
import LogIn from "./Page/LogIn/LogIn";
import { lazy, Suspense } from "react";
import { useStore } from "./store";
import SpinnerSelf from "./utils/Spinner/Spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SUserReport from "./components/SuperAdminReport/UserReport/SUserReport";
import AdminFoodReport from "./components/CFoodReport/AdminFoodReport";
import AdminHome from "./components/AdminHome/AdminHome";

const RegisterCategory = lazy(
  () => import("./components/Category/RegisterCategory/RegisterCategory")
);
const RegisterEmployee = lazy(
  () => import("./components/Employee/RegisterEmployee")
);

const RegisterEmployeeAdmin = lazy(
  () => import("./components/Employee/RegisterEmployeeAdmin")
);
const UserFeedback = lazy(() => import("./components/Feedback/UserFeedback"));
const FoodList = lazy(() => import("./components/Foodlist/Foodlist"));
const MenuList = lazy(() => import("./components/Menu/MenuList/MenuList"));
const RegisterOrg = lazy(() => import("./components/RegisterOrg/RegisterOrg"));
const RegisterOrganization = lazy(
  () => import("./components/RegisterOrganization/RegisterOrganization")
);
const RegisterRole = lazy(
  () => import("./components/Role/RegisterRole/RegisterRole")
);
const RegisterPermission = lazy(
  () => import("./components/SuperAdmin/RegisterPermission/RegisterPermission")
);
const ViewPermission = lazy(
  () => import("./components/SuperAdmin/ViewPermission/ViewPermission")
);
const CanteenAdmin = lazy(() => import("./Page/CanteenAdmin"));
const Dashboard = lazy(() => import("./Page/CanteenAdmin/Dashboard"));
const Orglist = lazy(() => import("./Page/Orglist/Orglist"));
const SuperAdmin = lazy(() => import("./Page/SuperAdmin/SuperAdmin"));
const UserDashboard = lazy(() => import("./Page/UserDashboard/UserDashboard"));
const Userlist = lazy(() => import("./Page/Userlist/Userlist"));

const ViewCategory = lazy(
  () => import("./components/Category/ViewCategory/ViewCategory")
);
const ComplainView = lazy(() => import("./components/Complaints/ComplainView"));
const ViewEmployee = lazy(() => import("./components/Employee/ViewEmployee"));
const OrganizationExpenseReport = lazy(
  () => import("./components/TotalExpenseReport/Index")
);
// import UserListItem from "./components/Role/Role";
const CanteenReport = lazy(() => import("./components/CanteenReport/Index"));
const UserReport = lazy(() => import("./Page/UserReport/Index"));

const AdminEmpExpReport = lazy(
  () => import("./components/AdminEmpExpReport/AdminEmpExpReport")
);
const BulkEmpAdd = lazy(() => import("./components/BulkEmpAdd/BulkEmpAdd"));
const CFoodReport = lazy(() => import("./components/CFoodReport/CFoodReport"));
const ForgotPassword = lazy(
  () => import("./components/ForgotPassword/ForgotPassword")
);
const RecentMenu = lazy(() => import("./components/RecentMenu/RecentMenu"));
const ResetPassword = lazy(
  () => import("./components/ResetPassword/ResetPassword")
);
const ViewVat = lazy(() => import("./components/VAT/ViewVat"));
const ChangePassword = lazy(
  () => import("./Page/ChangePassword/ChangePassword")
);
const SpDashboard = lazy(() => import("./Page/SuperAdmin/SpDashboard"));
function App() {
  const [state, dispatch] = useStore();

  return (
    <div className="app">
      <GlobalStyle />
      <Suspense fallback={<SpinnerSelf backDrop={true} />}>
        <Routes>
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* USER  */}
          <Route element={<ProtectedRoutes />}>
            <Route
              path="/userDashboard"
              element={
                <RoleProtectedRoutes
                  isAllowed={
                    `${state.authReducer.role.toLowerCase()}` === "user" ||
                    `${state.authReducer.role.toLowerCase()}` === "admin"
                  }
                >
                  <UserDashboard />
                </RoleProtectedRoutes>
              }
            ></Route>
            <Route
              path="/userdashboard/userdashboard/feedback"
              element={<UserFeedback />}
            />
            <Route
              path="/userdashboard/categories/:categoriesName"
              element={<UserDashboard />}
            />
            <Route
              path="/userdashboard/userdashboard/reports"
              element={<UserReport />}
            />

            <Route path="/registerorg" element={<RegisterOrg />} />
            {/* SUPERADMIN  */}
            <Route
              path="/spadmin"
              element={
                <RoleProtectedRoutes
                  isAllowed={
                    `${state.authReducer.role.toLowerCase()}` === "super_admin"
                  }
                >
                  <SuperAdmin />
                </RoleProtectedRoutes>
              }
            >
              <Route path="" element={<SpDashboard />} />
              {/* <Route path="all/:roleType" element={<Userlist />} /> */}
              <Route path="all" element={<Userlist />}>
                <Route path=":roleType" element={<Userlist />} />
              </Route>
              <Route path="companyList" element={<Orglist />} />
              <Route path="permissions" element={<ViewPermission />} />
              <Route
                path="create/permission"
                element={<RegisterPermission />}
              />
              <Route path="/spadmin/registerRole" element={<RegisterRole />} />
              <Route path="registerprofile" element={<RegisterEmployee />} />
              <Route
                path="registercompany"
                element={<RegisterOrganization />}
              />
              <Route path="allreport" element={<CFoodReport />} />
              <Route path="companyuserreport" element={<SUserReport />} />
            </Route>

            {/* CANTEENADMIN  */}
            <Route
              path="/cadmin"
              element={
                <RoleProtectedRoutes
                  isAllowed={
                    `${state.authReducer.role.toLowerCase()}` === "system_admin"
                  }
                >
                  <CanteenAdmin />
                </RoleProtectedRoutes>
              }
            >
              <Route path="" element={<Dashboard />} />
              <Route path="viewfood" element={<FoodList />} />
              <Route path="registercategory" element={<RegisterCategory />} />
              <Route path="viewcategory" element={<ViewCategory />} />
              <Route path="companyuserreport" element={<SUserReport />} />
              <Route path="expensereport" element={<CanteenReport />} />
              <Route path="foodexpense" element={<CFoodReport />} />
              <Route
                path="totalexpensereport"
                element={<OrganizationExpenseReport />}
              />

              {/* <Route path="addmenu" element={<RegisterMenu />} /> */}
              <Route path="viewmenu" element={<MenuList />} />
              <Route path="recentmenu" element={<RecentMenu />} />
              <Route path="complainview" element={<ComplainView />} />
              {/* <Route path="createvat" element={<CreateVat />} /> */}
              <Route path="viewvat" element={<ViewVat />} />
            </Route>
          </Route>

          <Route path="/" element={<LogIn />} />

          <Route path="/registeruser" element={<RegisterEmployee />} />

          <Route path="/registerorg" element={<RegisterOrg />} />

          {/* ADMIN  */}
          <Route
            path="/admin"
            element={
              <RoleProtectedRoutes
                isAllowed={
                  `${state.authReducer.role.toLowerCase()}` === "admin"
                }
              >
                <Admin />
              </RoleProtectedRoutes>
            }
          >
            <Route path="dashboard" element={<AdminHome />} />
            <Route path="createemployee" element={<RegisterEmployeeAdmin />} />
            <Route path="viewemployee" element={<ViewEmployee />} />
            <Route path="bulk-Employee-Add" element={<BulkEmpAdd />} />
            {/* <Route path="adminuserreport" element={<SUserReport />} /> */}
            <Route
              path="employee-Expense-Report"
              element={<AdminEmpExpReport />}
            />
            <Route path="sytemfoodreport" element={<AdminFoodReport />} />
          </Route>
          {/* employeeexpensereport */}

          {/* <Route path="/table" element={<ReactTable />} /> */}
          <Route
            path="*"
            element={
              <h1 className="d-flex justify-content-center mt-5">
                There's nothing here:<span style={{ color: "red" }}>404!</span>
              </h1>
            }
          />
        </Routes>
      </Suspense>

      <ToastContainer
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme={"colored"}
      />
    </div>
  );
}

export default App;
